// taken from https://docs.google.com/spreadsheets/d/13WY5UMs8YVFDCQUCYb9iE2PdGXTUN0uwTN9kyRteFlo/edit#gid=1621154918
export const questionQueryTypes = [
	"string",
	"integer",
	"decimal",
	"boolean",
	"enum",
	"json",
] as const;
export type QuestionQueryType = typeof questionQueryTypes[number];
